'use strict';
/**
 *  Module
 *  createBy   fanglijuan  2018-01-08
 * Description
 */
angular.module('allocationManageMentModule', ['allocationManageMentRouterModule'])
    .controller('allocationManageMentCtrl', ['$scope', "$element", "$state", '$modal', '$timeout', '$q', '$location', '$validation', '$stateParams', 'trsHttpService', 'jsonArrayToStringService', 'modalDialog', 'initAllocationDataService', 'initSingleSelecet', 'trsTransferService', 'productMangageMentNewspaperService',
        function($scope, $element, $state, $modal, $timeout, $q, $location, $validation, $stateParams, trsHttpService, jsonArrayToStringService, modalDialog, initAllocationDataService, initSingleSelecet, trsTransferService, productMangageMentNewspaperService) {

            /**
             * [getSiteRights description]获取每个站点的操作权限
             * @return null [description]123
             */
            var getSiteRights = function(SITEID) {
                productMangageMentNewspaperService.getRight(SITEID, "", "papersetpaper").then(function(data) {
                    $scope.status.rights[SITEID] = data;
                });
            };
            initStatus();
            initdata();
            //初始化状态
            function initStatus() {
                $scope.selectedArray = [];
                $scope.isSelected = "";
                $scope.chooseImages = initAllocationDataService.chooseImages();
                $scope.ACTUALPICINFO = initAllocationDataService.chooseImages();
                $scope.ICONPICINFO = initAllocationDataService.chooseImages();
                $scope.list = initAllocationDataService.initAllocation();
                $scope.list = {
                    "ISCREATEXIAOYANG": true,
                };
                $scope.selectedCheck = "";
                $scope.AllocationSelect = initAllocationDataService.initAllocationSelect();
                $scope.status = {
                    isTab: $location.path().split("/")[4],
                    item: "",
                    rights: {},
                    SITEID: $location.search().paper
                };
            }


            //初始化数据，初始化详情（回填内容）
            function initdata() {
                $scope.params = {
                    "serviceid": "mlf_paperset",
                    "methodname": "findPaperById",
                    "SiteId": $stateParams.paper
                };
                $scope.loadingPromise = trsHttpService.httpServer("/wcm/mlfcenter.do",
                    $scope.params, "post").then(function(data) {
                    $scope.status.item = data;
                    $scope.newsPaperInfo = {};
                    angular.extend($scope.newsPaperInfo, data); //兼容组版配置保存时，会清除报纸排重天数字段值的问题（组版配置保存需要完全提交报纸信息，否则就将视为重置属性值）
                    $scope.list = initAllocationDataService.initAllocation();
                    angular.extend($scope.list, data.ZHUBANSET);
                    selectDropDown($scope.list.SPACENUMTYPE);
                });

                getSiteRights($scope.status.SITEID);

            }
            //查询选择框
            function selectDropDown(typeid) {
                var json = initAllocationDataService.initAllocationSelect();
                var DefaultOBJ = {};
                for (var i in json) {
                    if (json[i].value == typeid) {
                        DefaultOBJ.name = json[i].name;
                        break;
                    }
                }
                $scope.selectdTimeDefault = DefaultOBJ;
            }
            //单选
            $scope.selectDoc = function(params) {
                eval(params);
            };
            //小样单选缩进
            $scope.queryByTimeType = function() {
                $scope.list.SPACENUMTYPE = angular.copy($scope.selectdTimeDefault).value;
            };
            //图像质量选择
            $scope.selectGenre = function(chooseImage) {

                $scope.list.BRIEFPICINFO.QUALITY = chooseImage.value

            };
            //版面质量选择
            $scope.selectBM = function(genre) {

                $scope.list.ACTUALPICINFO.QUALITY = genre.value;
            };
            //版面小图标选择
            $scope.selectIcon = function(genre) {

                $scope.list.ICONPICINFO.QUALITY = genre.value;
            };


            $scope.checkbox = function(params) {
                var flag = false;
                angular.forEach($scope.selectedArray, function(data, index, array) {
                    if (params === 1) {
                        flag = true;
                    }
                });
                return flag;
            };
            //添加版面样式
            $scope.add_edit = function() {
                var selectedUsers = handleSelectedUser($scope.list.EDITORS, "EDITORS");
                trsTransferService.getUser(function(data) {
                    $scope.list.EDITORS = [];
                    angular.forEach(data, function(data, index, array) {
                        $scope.list.EDITORS.push({
                            "ID": data.ID,
                            "NAME": data.USERNAME,
                        });
                    });
                }, "", selectedUsers);
            };
            //添加签样者
            $scope.add_sign = function() {
                var selectedUsers = handleSelectedUser($scope.list.SIGNUSES, "SIGNUSES");
                trsTransferService.getUser(function(data) {
                    $scope.list.SIGNUSES = [];
                    angular.forEach(data, function(data, index, array) {
                        $scope.list.SIGNUSES.push({
                            "ID": data.ID,
                            "NAME": data.USERNAME,
                        });
                    });
                }, "", selectedUsers);
            };
            /**
             * [handleSelectedUser description：预处理已选的用户列表]
             * @param  {[array]} selectedUsers  [description:已选用户列表]
             * @param  {string} [varname] [description] 用户属性名称
             * @return {[array]} selectedUsers  [description]处理完成的已选用户列表
             */
            function handleSelectedUser(selectedUsers, attributeName) {
                var array = [];
                for (var i = 0; i < $scope.list[attributeName].length; i++) {
                    $scope.list[attributeName][i].DESC = $scope.list[attributeName][i].NAME;
                    $scope.list[attributeName][i].USERNAME = $scope.list[attributeName][i].NAME;
                    array.push($scope.list[attributeName][i]);
                }
                return array;
            }
            //保存
            $scope.save = function() {
                save();
            };
            //重置
            $scope.reset = function() {
                modalDialog.alertType("确定重置？", "", "ask", true, function() {
                    initdata();
                });
            };
            //删除
            $scope.remove_edit = function(item) {
                $scope.selected = item;
                $scope.list.EDITORS.splice($scope.list.EDITORS.indexOf($scope.selected), 1);
            };
            //删除
            $scope.remove_edits = function(item) {
                $scope.selected = item;
                $scope.list.SIGNUSES.splice($scope.list.SIGNUSES.indexOf($scope.selected), 1);
            };
            //刷新页面
            function freshParent(callback) {
                window.opener.location.reload();
                setTimeout(function() {
                    callback();
                }, 500);
            }

            //取消 退出页面
            $scope.cancel = function() {
                if ($scope.allocationForm.$dirty === true) {

                }
            };
            //保存
            function save() {
                var deferred = $q.defer();
                $validation.validate($scope.allocationForm).success(function() {
                    var vlist = angular.copy($scope.list);
                    //vlist = jsonArrayToStringService.jsonArrayToString(vlist);
                    vlist = JSON.stringify(vlist);
                    var params = {
                        "serviceid": "mlf_paperset",
                        "methodname": "saveZhuBanSet",
                        'ZhuBanSet': vlist,
                        'ObjectId': $stateParams.paper,
                    };
                    delete $scope.newsPaperInfo.ZHUBANSET;
                    angular.extend(params, $scope.newsPaperInfo);
                    trsHttpService.httpServer("/wcm/mlfcenter.do", params, "post").then(function(data) {
                        // $scope.list.METADATAID = data.METADATAID;
                        // $scope.list.CHNLDOCID = data.CHNLDOCID;
                        // $stateParams.chnldocid = $scope.list.CHNLDOCID;
                        // $stateParams.metadataid = $scope.list.METADATAID;
                        $stateParams.status = 0;
                        $scope.selectedArray = [{
                            'TITLE': $scope.list.TITLE,
                            'CHNLDOCID': $scope.list.CHNLDOCID,
                            'METADATAID': $scope.list.METADATAID
                        }];
                        deferred.resolve(data);
                        modalDialog.alertType("保存成功", "", "success", false, function() {
                            /*initdata();
                            freshParent(function() {
                                window.location.reload();
                            });*/
                            $timeout(function() {
                                initdata();
                            }, 500);
                        });
                    });
                    return deferred.promise;
                }).error(function() {
                    angular.invalidPosition($scope.allocationForm, $element);
                    //modalDialog.alertType("提交失败", "必填项未填写", "error", false, function() {});
                });
            }



        }
    ]);